<div class="orgbrain-style">
  <mat-form-field appearance="outline" class="search-box">
    <mat-label>{{ label || 'search' }}</mat-label>
    <input
      type="text"
      (focus)="focus()"
      matInput
      [formControl]="searchControl"
      [matAutocomplete]="auto"
      id="_orgbrain_chooser_input"
    />
    <mat-select> </mat-select>

    @if (searchControl.value && searchControl.value !== '') {
      <button mat-icon-button matSuffix (click)="removeSearch()" type="button">
        <mat-icon matSuffix>close</mat-icon>
      </button>
    }
  </mat-form-field>

  <mat-autocomplete #auto="matAutocomplete" class="white-scroll">
    <mat-option *ngFor="let item of items">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"> </ng-container>
    </mat-option>
  </mat-autocomplete>
</div>
